import { render } from "./IconPencil.vue?vue&type=template&id=0b0790f2"
import script from "./IconPencil.vue?vue&type=script&lang=js"
export * from "./IconPencil.vue?vue&type=script&lang=js"
script.render = render

export default script